import * as universal from '../entries/pages/_page.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/+page.ts";
export const imports = ["_app/immutable/nodes/3.CBMkeSmU.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/CWir8Kn7.js","_app/immutable/chunks/CpR9_xLq.js","_app/immutable/chunks/BvDXOag0.js","_app/immutable/chunks/CiMXKxQ-.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/pTubWVUb.js","_app/immutable/chunks/BN8CHBz-.js"];
export const stylesheets = ["_app/immutable/assets/3.CjAA0KPm.css"];
export const fonts = [];
